<template>
  <div>
    <div class="overlay-sub" :class="[stories_drawer ? 'overlay open' : 'overlay']" @click="closeDrawer()"></div>
    <div class="media-detail-modal" :class="[stories_drawer ? 'open' : '']">
      <div class="detail-modal w-100">
        <div class="detail-profile-wrap">
          <div class="detail-profile-img-area">
            <a :href="'https://instagram.com/' + profile_data.account_name + '/'" target="_blank">
              <el-image class="detail-profile_img" :src="search_type == 'request_pr' ? post_data.profile_picture_url : profile_data.profile_picture_url">
                <div slot="error" class="data-table-profile-noimg">
                  NO
                  <br />IMAGE
                </div>
              </el-image>
            </a>
          </div>
          <div class="detail-profile-name-area">
            <div class="detail-profile-name">{{ profile_data.account_name }}</div>
            <div class="detail-location" v-if="stories_data && stories_data.location">
              <font-awesome-icon :icon="['fas', 'map-marker-alt']" style="margin-right: 3px;" />
              {{ stories_data.location[0].location.name }}
            </div>
          </div>
        </div>
        <div class="stories-detail w-100" v-if="stories_data">
          <img v-if="stories_data.media_type == 1" :src="s3BaseUrl + '/stories/' + stories_data.story_id + '.jpg'" alt="" />
          <video v-if="stories_data.media_type == 2" :src="s3BaseUrl + '/stories/' + stories_data.story_id + '.mp4'" autoplay muted loop controls alt=""></video>
          <div class="mask stories-detail" style="margin-top: 10px;">
            <div v-show="stories_data.link_stickers">
              <a v-for="link_sticker in stories_data.link_stickers" :key="link_sticker.id" style="margin-right:10px" class="story-link pointer" :href="link_sticker.story_link.url" target="_blank">
                <font-awesome-icon :icon="['fas', 'link']" style="margin-right: 3px;" />
                {{ link_sticker.story_link.display_url }}
              </a>
            </div>
            <div v-show="stories_data.mentiontag">
              <span v-for="mentiontag in stories_data.mentiontag" :key="mentiontag.id" style="margin-right:10px">
                {{ "@" + mentiontag.user.username }}
              </span>
            </div>
            <div v-show="stories_data.bloks_stickers">
              <span v-for="bloks_stickers in stories_data.bloks_stickers" :key="bloks_stickers.id" style="margin-right:10px">
                {{ "@" + bloks_stickers.bloks_sticker.sticker_data.ig_mention.username }}
              </span>
            </div>
            <div v-show="stories_data.hashtag">
              <span v-for="hashtag in stories_data.hashtag" :key="hashtag.id" style="margin-right:10px">
                {{ "#" + hashtag.hashtag.name }}
              </span>
            </div>
            <div v-show="stories_data.location">
              <span v-for="location in stories_data.location" :key="location.id" style="margin-right:10px">
                <font-awesome-icon :icon="['fas', 'map-marker-alt']" style="margin-right: 3px;" />
                {{ location.location.name }}
              </span>
            </div>
            <div>{{ stories_data.created_at }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["stories_drawer", "profile_data", "stories_data", "search_type", "search_keyword", "pr_word"],
  name: "storiesDetail",
  data() {
    return {
      detail_loading: true,
      tagged_user: false,
      actionId: Math.floor(new Date().getTime() / 1000),
      s3BaseUrl: process.env.VUE_APP_S3_BASE_URL,
    };
  },
  methods: {
    imgDetailLoaded() {
      this.detail_loading = false;
    },
    closeDrawer() {
      this.detail_loading = true;
      this.actionId += 1;
      this.$emit("closeDrawer", "stories");
    },
    tagged_show() {
      this.tagged_user = !this.tagged_user;
    },
  },
  filters: {
    searchHighlight(value, keyword, pr) {
      if (keyword) {
        const keyword_rep1 = keyword.replace(/OR/g, "|");
        const keyword_rep2 = keyword_rep1.replace(/"/g, "");
        const keyword_rep3 = keyword_rep2.replace(/\s/g, "|");
        const keyword_RegExp = new RegExp(keyword_rep3, "ig");
        return value.replace(keyword_RegExp, (keyword) => '<span class="data-table-th-highlight">' + keyword + "</span>");
      } else if (pr == true) {
        if (this.search_type == "pr") {
          var pr_regexp = this.pr_word;
        }
        const keyword_RegExp = new RegExp(pr_regexp, "ig");
        return value.replace(keyword_RegExp, (keyword) => '<span class="data-table-th-highlight">' + keyword + "</span>");
      } else {
        return value;
      }
    },
  },
};
</script>

<style></style>
